import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../../deployment';

@Injectable({
  providedIn: 'root'
})
export class EcastudentsService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  userList($data:any){
    return this.http.post(checkUrl()+"/ecademic/admin/list",$data)
    .pipe((response)=>{
      return response;
    });
  }

  deleteUser($data:any){
    return this.http.post(checkUrl()+"/ecademic/admin/delete",$data)
    .pipe((response)=>{
      return response;
    });
   }
  }
  

